const url =
  typeof window !== 'undefined' ? new URL(window.location.href) : undefined;
const paths = url?.pathname.split('/');

export const appId = paths?.[paths.length - 2];
